(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["custom-static-header-with-slider"]) return;
  try {
    
  var texts = [
    'Save 10% on your first order. USE CODE: 10OFF. <a href="https://shimmerandconfetti.com/pages/claim-your-10-coupon" target="_blank">Learn more</a>',
    'Free Shipping over $25. <a href="https://shimmerandconfetti.com/pages/shipping" target="_blank">Learn more</a>',
    'Buy Now Pay Later. <a href="https://shimmerandconfetti.com/pages/pay-in-4-installments-klarna" target="_blank">Learn more</a>',
  ];
  var currentIndex = 0;

  function updateBannerText() {
    document.getElementById('banner-text').innerHTML = texts[currentIndex];
  }

  setInterval(function() {
    currentIndex++;
    if (currentIndex >= texts.length) {
      currentIndex = 0;
    }
    updateBannerText();
  }, 5000); // changes every 5 seconds

  document.getElementById('prev-text').addEventListener('click', function() {
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = texts.length - 1;
    }
    updateBannerText();
  });

  document.getElementById('next-text').addEventListener('click', function() {
    currentIndex++;
    if (currentIndex >= texts.length) {
      currentIndex = 0;
    }
    updateBannerText();
  });

  document.getElementById('close-banner').addEventListener('click', function() {
    document.getElementById('custom-banner').style.display = 'none';
  });

  // Initial text
  updateBannerText();

  } catch(e) { console.error(e); }
})();

})();
